import React from 'react';
import { Global } from '@emotion/react';

/* ======================================== */

const iconSize = 20;

const commonPrefix = `<svg width="${iconSize}" height="${iconSize}" xmlns="http://www.w3.org/2000/svg" fill="rgb(65,65,65)" viewBox="-5 -5 30 30">`;
const commonSuffix = `</svg>`;
const iconChevron = `${commonPrefix}<polygon points="16.1,14.5 9.9,8.3 3.7,14.5 2.2,13.0 9.9,5.2 17.7,13.0"/>${commonSuffix}`;
const iconDash = `${commonPrefix}<polygon opacity="0.4" points="16.1,14.5 3.7,14.5 2.2,13.0 17.7,13.0"/>${commonSuffix}`;
const iconArrow = `${commonPrefix}<polygon points="16.1,14.5 3.7,14.5 2.2,13.0 9.9,5.2 17.7,13.0"/>${commonSuffix}`;

const inlineIcon = (svg: string) => `url("data:image/svg+xml;utf8,${svg.replace(/"/g, '\\\'')}")!important`;

/**
 * Global styles to override devExpress / devExtreme icons
 * Two reasons for overriding them:
 * - to match pre-existing adserve icon styles
 * - bundling devExtreme icon font files in a library not behaving correctly!
 * As global styles these *should* apply to all instances - whether children of the datagrid (header sort icons) or external to the grid (context menu sort icons)
 * @private
 * !! Do not export from the library !!
  */
export const StyledGlobal: React.FC = () => {
    return (
        <Global
            styles={{
                '.dx-widget, .dx-overlay-wrapper': {
                    fontFamily: 'Roboto, Arial, sans-serif'
                },

                '.dx-widget .dx-scrollable-native-generic > .dx-scrollable-wrapper': {
                    boxShadow: 'outset 0px 0px 0px 20px rgba(0,0,0,0.09)'
                },

                '.dx-column-indicators > .dx-sort': {
                    marginTop: 4,
                },
                '.dx-sort-up::before, .dx-icon-context-menu-sort-asc::before': {
                    display: 'inline-block',
                    width: iconSize,
                    height: iconSize,
                    content: inlineIcon(iconChevron)
                },
                '.dx-sort-down::before, .dx-icon-context-menu-sort-desc::before': {
                    display: 'inline-block',
                    width: iconSize,
                    height: iconSize,
                    content: inlineIcon(iconChevron),
                    transform: 'rotate(180deg)'
                },
                '.dx-sort-none': {
                    display: 'inline-block!important',
                    width: iconSize,
                    height: iconSize,
                    content: inlineIcon(iconDash)
                },
                '.dx-sort-index-icon': {
                    position: 'relative',
                    top: -6,
                    fontSize: 11
                },

                '.dx-datagrid-group-opened': {
                    display: 'inline-block',
                    width: iconSize,
                    height: iconSize,
                    content: inlineIcon(iconArrow),
                    transform: 'rotate(180deg)'
                },
                '.dx-datagrid-group-closed': {
                    display: 'inline-block',
                    width: iconSize,
                    height: iconSize,
                    content: inlineIcon(iconArrow),
                    transform: 'rotate(90deg)'
                }
            }}
        />
    );
};
